import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { FiltersStateOfm, InvoiceModel, InvoiceType } from "./type";

const initialState: FiltersStateOfm = {
  fromDate: null,
  toDate: null,
  filters: { codes: [] },
};

const ofmFiltersSlice = createSlice({
  name: "ofmFilters",
  initialState,
  reducers: {
    setFromDate(state, action: PayloadAction<Date | null>) { state.fromDate = action.payload; },
    setToDate(state, action: PayloadAction<Date | null>)   { state.toDate = action.payload; },

    setCode(state, action: PayloadAction<string | undefined>) { state.filters.code = action.payload; },
    setCodes(state, action: PayloadAction<string[]>)          { state.filters.codes = action.payload ?? []; },

    setCodInvoiceModel(state, action: PayloadAction<InvoiceModel | undefined>) { state.filters.codInvoiceModel = action.payload; },
    setCouponType(state, action: PayloadAction<InvoiceModel | undefined>)      { state.filters.couponType = action.payload; },

    setInvoiceType(state, action: PayloadAction<InvoiceType | undefined>) { state.filters.invoiceType = action.payload; },
    setEntryExit(state, action: PayloadAction<InvoiceType | undefined>)   { state.filters.entryExit = action.payload; },


    resetAll() { return initialState; },
  },
});

export const {
  setFromDate, setToDate,
  setCode, setCodes,
  setCodInvoiceModel, setCouponType,
  setInvoiceType, setEntryExit,
  resetAll,
} = ofmFiltersSlice.actions;

export default ofmFiltersSlice.reducer;
